import {AxiosError} from "axios";

export function axiosErrorInterceptor(error: unknown): unknown {
    if(error instanceof AxiosError) {
        // strip out the auth from the error
        if(error.config) {
            const newConfig = {...error.config}
            delete newConfig.auth
            error.config = newConfig
        }
    }
    return Promise.reject(error)
}